import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import formatCurrency from '@afosto/utils/formatCurrency';
import translations from './translations';
import { FormattedMessage } from 'react-intl';

const PaymentCard = ({ payment }) => {
  const intl = useIntl();
  const renderChip = () => {
    const chipOptions = {};

    if (payment.is_paid) {
      chipOptions.label = intl.formatMessage(translations.chip.paid);
      chipOptions.color = 'default';
    }

    if (payment.is_pending) {
      chipOptions.label = intl.formatMessage(translations.chip.unpaid);
      chipOptions.color = 'secondary';
    }

    if (payment.is_pending && payment.amount_paid > 0) {
      chipOptions.label = intl.formatMessage(translations.chip.partlyPaid);
      chipOptions.color = 'primary';
    }

    return (
      <Chip label={chipOptions?.label} color={chipOptions?.color} variant="outlined" size="small" />
    );
  };

  return (
    <>
      <Divider variant="middle" />
      <ListItem>
        <Box flex={1}>
          <Box display="flex" justifyContent="space-between" flex={1} pt={1}>
            <Box flex={1}>
              <Typography variant="subtitle1">
                {
                  payment?.providers?.[payment?.provider_code]?.methods?.[payment?.method_code]
                    ?.name
                }
                {payment?.issuer_code &&
                  ` (${
                    payment?.providers?.[payment?.provider_code]?.methods?.[payment?.method_code]
                      ?.issuers[payment?.issuer_code]?.name
                  })`}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {payment?.providers?.[payment?.provider_code]?.name}
              </Typography>
            </Box>
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <Typography variant="caption" color="textSecondary" component="div" gutterBottom>
                {formatDateTime(payment?.created_at)}
              </Typography>
              {renderChip()}
            </Box>
          </Box>
          <Box display="flex" justifyContent="space-between" flex={1} pt={1} pb={1}>
            <Box>
              <Typography variant="overline" color="textSecondary">
                <FormattedMessage {...translations.properties.paidAt} />
              </Typography>
              <Typography variant="body2">
                {payment?.paid_at ? formatDateTime(payment.paid_at) : '-'}
              </Typography>
            </Box>
            <Box>
              <Typography variant="overline" color="textSecondary">
                <FormattedMessage {...translations.properties.amount} />
              </Typography>
              <Typography variant="body2">
                {formatCurrency(payment?.is_refund ? payment?.amount * -1 : payment?.amount)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </ListItem>
    </>
  );
};

PaymentCard.propTypes = {
  payment: PropTypes.object,
};

PaymentCard.defaultProps = {
  payment: null,
};

export default PaymentCard;
